// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationPharmacyInsurance {
    static getAttributeTypeMap() {
        return ClaimAdjudicationPharmacyInsurance.attributeTypeMap;
    }
}
ClaimAdjudicationPharmacyInsurance.discriminator = undefined;
ClaimAdjudicationPharmacyInsurance.attributeTypeMap = [
    {
        "name": "pbmName",
        "baseName": "pbmName",
        "type": "string"
    },
    {
        "name": "rxGroup",
        "baseName": "rxGroup",
        "type": "string"
    },
    {
        "name": "rxMemberId",
        "baseName": "rxMemberId",
        "type": "string"
    },
    {
        "name": "rxPcn",
        "baseName": "rxPcn",
        "type": "string"
    },
    {
        "name": "rxBin",
        "baseName": "rxBin",
        "type": "string"
    }
];
//# sourceMappingURL=claimAdjudicationPharmacyInsurance.js.map